
import vTooltip from "~/components/global/v-tooltip.vue";
import { mdiCheck, mdiCheckboxBlankCircle } from "@mdi/js";

export default {
  components: { vTooltip },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },

  layout: "auth",
  middleware: "auth",
  auth: "guest",

  data() {
    return {
      mdiCheck,
      mdiCheckboxBlankCircle,
      nothing: "",
      prevRoute: null,
      dataBackgroundWebp: "bg.webp",
      dataBackgroundJpeg: "bg.jpg",
      successSent: false,
      valid: false,
      showPass: false,
      emailRules: [
        (v) => !!v || this.$t("validations.the-email-field-is-required"),
        (v) =>
          /^\w+([.-]?\w+)*(?:\+\d+)?@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("validations.e-mail-must-be-valid"),
      ],
      form: {
        email: "",
        userType: "3",
      },
      error: {
        status: false,
        msg: "",
      },
      loading: false,
    };
  },

  created() {
    if (this.$store.$auth.$state.loggedIn) {
      this.$router.push("/dashboard");
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },

    async submitForm() {
      this.loading = true;
      try {
        const responce = await this.$axios.$post("/api/auth/email", this.form);

        if (responce.status) {
          this.resetError();

          this.successSent = true;
        } else {
          this.error.status = true;
          this.error.msg = responce.msg?.email?.at(0) || responce.msg;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    resetError() {
      this.error.status = false;
      this.error.msg = "";
    },
  },
};
